export function SET_MENU(state, menu) {
  state.menu = menu
}
